import Tour from 'app/shared/model/Tour';

const EditListingPageInitState = {
    activationErrors: [],
    showReadyToPublishMessage: false,
    expirationDate: null,
    canAccessApplications: false,
    formErrorMessage: '',
    hasErrors: false,
    isLoading: true,
    isRequestingListingUpdate: false,
    notFound: false,
    propertyId: '',
    statusMessage: '',
    savedStatus: '',
    listingSubmitted: false,
    showPostActivationModal: false,
    isListingPhotoProcessing: false,
    inputOnFocus: { // Store init value of input box to prevent sending API requests if no data changed.
        field: '',
        value: '',
    },
    showBuildingAttributesUpdatedWarning: false,
    showAddressAlreadyPostedBanner: false,
    duplicateSyndicatedUrl: '',
    formData: {
        isViewable: true,
        active: false,
        leaseDuration: '',
        buildingAttributes: {
            storyCount: '',
            yearBuilt: '',
            yearRemodeled: '',
            hasOnsiteManagement: false,
            smokingAllowed: false,
            isOver55: false,
            hasOnlineRentPayment: false,
            hasOnlineMaintenancePortal: false,
            hasDryCleaningDropOff: false,
            hasElevator: false,
            hasGuestSuite: false,
            hasHotTub: false,
            hasSauna: false,
            hasSwimmingPool: false,
            hasStorageSpace: false,
            hasBicycleStorage: false,
            hasSharedLaundry: false,
            hasPackageService: false,
            hasPetPark: false,
            hasBarbecue: false,
            hasFireplace: false,
            hasCeilingFan: false,
            isFurnished: false,
            hasPatioBalcony: false,
            hasTwentyFourHourMaintenance: false,
            hasSpanishSpeakingStaff: false,
            hasValetTrash: false,
            hasAssistedLiving: false,
            hasDisabledAccess: false,
            isIncomeRestricted: false,
            zillowDescription: '',
            petPolicyDescription: '',
            nearbyAmenity1: '',
            nearbyAmenity2: '',
            nearbyAmenity3: '',
            nearbyAmenity4: '',
            parkingDescription: '',
            parkingRentDescription: '',
            associationName: '',
            managerName: '',
            architect: '',
            busesNearby: '',
            railNearby: '',
            airConditioningTypes: {
                hasAny: false,
                hasCentral: false,
                hasWall: false,
                hasWindow: false,
            },
            applianceTypes: {
                hasDishwasher: false,
                hasDryer: false,
                hasFreezer: false,
                hasGarbageDisposal: false,
                hasMicrowaveOven: false,
                hasOven: false,
                hasRange: false,
                hasRefrigerator: false,
                hasStove: false,
                hasTrashCompactor: false,
                hasWasher: false,
                hasWasherDryerHookups: false,
                hasConvectionOven: false,
                hasDoubleOven: false,
            },
            communicationTypes: {
                hasHighSpeedInternet: false,
                hasCableTv: false,
                hasSatelliteTv: false,
                hasBuildingWideWireless: false,
            },
            communityRoomTypes: {
                hasFitnessCenter: false,
                hasTheater: false,
                hasClubHouse: false,
                hasGameRoom: false,
                hasBusinessCenter: false,
                hasConferenceRoom: false,
                hasLibrary: false,
                hasPartyRoom: false,
                hasPetWashingStation: false,
                hasLounge: false,
            },
            floorCoveringTypes: {
                hasCarpet: false,
                hasConcrete: false,
                hasHardwood: false,
                hasLaminate: false,
                hasLinoleum: false,
                hasMarble: false,
                hasSlate: false,
                hasSoftwood: false,
                hasTile: false,
                hasVinyl: false,
            },
            heatingSourceTypes: {
                hasElectric: false,
                hasGas: false,
                hasHeatPump: false,
                hasOil: false,
                hasPropaneButane: false,
                hasSolar: false,
            },
            leaseLengths: {
                hasOneYear: false,
                hasMoreThanOneYear: false,
                hasLessThanOneYear: false,
                hasSixMonth: false,
                hasMonthly: false,
                hasFlexible: false,
            },
            outdoorCommonAreaTypes: {
                hasRooftopDeck: false,
                hasDeck: false,
                hasPatio: false,
                hasGarden: false,
                hasPicnicArea: false,
                hasPlayground: false,
                hasLawn: false,
                hasGazebo: false,
                hasWaterFeature: false,
                hasTrail: false,
            },
            parkingTypes: {
                hasParkingLot: false,
                hasUndergroundGarage: false,
                hasCoveredParking: false,
                hasAttachedGarage: false,
                hasDetachedGarage: false,
                hasMultiLevelGarage: false,
            },
            securityTypes: {
                hasDoorman: false,
                hasControlledAccess: false,
                hasIntercom: false,
                hasGatedEntry: false,
                hasNightPatrol: false,
            },
            sportCourtTypes: {
                hasBasketball: false,
                hasBocce: false,
                hasMultiPurpose: false,
                hasShuffleboard: false,
                hasRacquetball: false,
                hasSportsField: false,
                hasTennis: false,
                hasVolleyball: false,
                hasOther: false,
            },
            utilitiesIncluded: {
                hasCableTv: false,
                hasElectricity: false,
                hasGarbage: false,
                hasGas: false,
                hasHeating: false,
                hasAirConditioning: false,
                hasInternet: false,
                hasSewage: false,
                hasWater: false,
                hasHotWater: false,
            },
            viewTypes: {
                hasCity: false,
                hasGolfCourse: false,
                hasMountain: false,
                hasPark: false,
                hasTerritorial: false,
                hasWater: false,
                hasWooded: false,
            },
            specialOffers: [{
                id: null,
                description: null,
                beginDate: null,
                endDate: null,
            }],
        },
        isPopulatedFromBuildingAttributeDatabase: false,
        isPaidMultifamily: false,
        listingType: '',
        propertyType: '',
        listingTypeCode: '',
        propertyTypeCode: '',
        street: '',
        unit: '',
        city: '',
        state: '',
        zip: '',
        hideAddress: false,
        forRentBy: '',
        contactName: '',
        contactPhone: '',
        contactFax: '',
        contactEmail: '',
        ccToEmail: '',
        listingTitle: '',
        description: '',
        specials: '',
        leaseTerms: '',
        floorplans: [],
        units: [],
        tour: new Tour(),
        amenities: [],
        apartmentAmenities: [],
        amenitiesText: '',
        photos: [],
        laundry: '',
        website: '',
        numUnits: '',
        logo: {},
        buildingUnitCount: '',
        airConditioning: '',
        balconyOrDeck: '',
        furnished: '',
        hardwoodFloors: '',
        wheelchairAccess: '',
        garageParking: '',
        offStreetParking: '',
        contactHours: {
            sunday: '',
            monday: '',
            tuesday: '',
            wednesday: '',
            thursday: '',
            friday: '',
            saturday: '',
        },
        isApplicationsAccepted: null,
    },
    errorObj: {
        street: null,
        unit: null,
        city: null,
        state: null,
        zip: null,
        hideAddress: null,
        forRentBy: null,
        contactName: null,
        contactPhone: null,
        contactFax: null,
        contactEmail: null,
        ccToEmail: null,
        listingTitle: null,
        logo: null,
        description: null,
        specials: null,
        leaseTerms: null,
        floorplans: [{
            id: '',
            name: '',
            description: '',
            squareFeet: 0,
            numBathrooms: 0,
            numBedrooms: 0,
            lowPrice: 0,
            highPrice: 0,
            active: null,
            floorPlanPhotos: [],
            unitAmenities: [],
            units: [],
            dateCreated: '',
        }],
        amenities: [],
        photos: null,
        laundry: null,
        noPets: null,
        website: null,
        numUnits: null,
        buildingUnitCount: null,
        airConditioning: null,
        balconyOrDeck: null,
        furnished: null,
        hardwoodFloors: null,
        wheelchairAccess: null,
        garageParking: null,
        offStreetParking: null,
        contactHours: {
            sunday: null,
            monday: null,
            tuesday: null,
            wednesday: null,
            thursday: null,
            friday: null,
            saturday: null,
        },
        petsAllowed: {
            cats: null,
            smallDogs: null,
            largeDogs: null,
            none: null,
        },
        specialOffers: null,
        isApplicationsAccepted: null,
    },
};

export default EditListingPageInitState;
